import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installFetchAuth } from "@/utils/apiAuth";

// Patch window.fetch once at boot so every API call inherits the Bearer
// token (works in browsers that block our cross-domain cookie, e.g. iOS Safari).
installFetchAuth();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
